/* eslint-disable @next/next/no-img-element */
import type React from "react";

interface MapThumbnailProps extends React.HtmlHTMLAttributes<HTMLImageElement> {
  city: string;
  stateProvince: string;
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  showMarker?: boolean;
}

const MapThumbnail: React.FC<MapThumbnailProps> = ({
  city,
  stateProvince,
  addressLine1,
  addressLine2,
  country,
  showMarker = true,
  ...props
}: MapThumbnailProps) => {
  const GOOGLE_MAPS_API_KEY = "AIzaSyCtKspCWYcWxOpKYmqrd2N-SiYOMOvsbXs";

  // Build the address query with all available components
  const addressParts = [
    addressLine1,
    addressLine2,
    city,
    stateProvince,
    country,
  ].filter(Boolean); // Remove empty/undefined values

  const fullAddress = addressParts.join(", ");

  // Build the map query
  let mapQuery = `center=${encodeURIComponent(fullAddress)}&zoom=13&size=144x144&maptype=roadmap`;

  // Add marker if requested
  if (showMarker) {
    mapQuery += `&markers=color:red|${encodeURIComponent(fullAddress)}`;
  }

  return (
    <img
      alt="Google Maps Thumbnail"
      src={`https://maps.googleapis.com/maps/api/staticmap?${mapQuery}&key=${GOOGLE_MAPS_API_KEY}`}
      {...props}
    />
  );
};

export default MapThumbnail;
